import { Breadcrumbs, CircularProgress, Grid2 } from "@mui/material";
import styles from "./AddDomain.module.scss";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { DomainStepper } from "../DomainStepper/DomainStepper";
import { DomainDetails } from "../DomainDetails/DomainDetails";
import CustomButton from "../../../../../../../../GlobalComponents/CustomButton/CustomButton";
import { PointYourDomain } from "../PointYourDomain/PointYourDomain";
import { AddSSL } from "../AddSSL/AddSSL";
import {
  CP,
  isValidDomain,
  isValidEmail,
} from "../../../../../../../../Utils/roconConstants";
import DoaminLoading from "../DomainLoading/DomainLoading";
import ReadyPage from "../ReadyPage/ReadyPage";
import FailedPage from "../FailedPage/FailedPage";
import { getStore } from "../../../../../../../../Utils/storeUtils";
import { Actions } from "../../../../../../../../redux/constants/actionTypes";

export function AddDomain(props) {
  const {
    navigate,
    step,
    setStep,
    orgId,
    siteId,
    domainName,
    loading,
    handleDomainAPI,
    domainError,
    siteData,
    checkAndSetDomainValue,
    flushStateVariables,
    errorMessage,
    setErrorMessage,
    ssldata,
    setSslData,
    privateKeyError,
    certificateChainError,
    sslAutoData,
    sslAutoDataErr,
    setSSLAutoData,
    tos,
    setTos,
    uploadClick,
    autoClick,
    cardStatus,
    selectTab,
    showReadyPage,
    setShowReadyPage,
    showFailedPage,
    setShowFailedPage,
    sslAuthChallenge,
    showPointYourDomain,
    setShowPointYourDomain,
    data,
    flushState,
    verifySsl,
    primary,
    domainAPI,
    setDomainName,
    showLoading,
    setShowLoading,
    isDedicated,
    installInstanceDomain,
    installing,
    failedMessage,
    dnsVerified,
    dnsChecking,
    isEbsSite,
    ebsDomain,
    verifyEbsDns,
  } = props;
  const [searchParams, setSearchParams] = useSearchParams();

  // Step mappings
  const stepMap = {
    "domain-details": 1,
    "point-your-domain": 2,
    "add-ssl": 3,
  };

  useEffect(() => {
    const stepParam = searchParams.get("status") || "domain-details";
    setStep(stepMap[stepParam] || 1);
  }, [searchParams]);

  useEffect(() => {
    if (step === 3 && cardStatus.value === "AutoSSL" && domainName) {
      setSSLAutoData((prev) => ({
        ...prev,
        domainName,
      }));
    }
  }, [step, cardStatus.value, domainName]);

  useEffect(() => {
    if (step === 4) {
      setShowLoading(true);
      setShowReadyPage(false);
      setShowFailedPage(false);
      setShowPointYourDomain(false);
      const showReadyTimer = setTimeout(() => {
        setShowLoading(false);
        setShowReadyPage(true);
        const redirectTimer = setTimeout(() => {
          navigate(`/account/${orgId}/${siteId}/domains-hosted`);
          getStore().dispatch({
            type: Actions.API_GET_SELECTED_SITE_DETAILS,
            data: { siteId: siteId },
          });
        }, 10000);
        return () => clearTimeout(redirectTimer);
      }, 2000);
      return () => clearTimeout(showReadyTimer);
    }
  }, [step, navigate]);

  const isUploadSSLComplete = () => {
    return (
      ssldata.privateKey?.trim() &&
      ssldata.certificateChain?.trim() &&
      !privateKeyError &&
      !certificateChainError
    );
  };

  const isAutoSSLComplete = () => {
    return (
      sslAutoData.email?.trim() &&
      isValidEmail(sslAutoData.email) &&
      sslAutoData.domainName?.trim() &&
      tos &&
      !sslAutoDataErr.email &&
      !sslAutoDataErr.domainName
    );
  };

  const isButtonDisabled =
    (step === 1 &&
      (!isValidDomain(domainName) || domainError || !!errorMessage)) ||
    (step === 2 &&
      (isEbsSite ? !ebsDomain?.validationName : !dnsVerified)) ||
    (step === 3 &&
      ((cardStatus.value === "UploadSSL" && !isUploadSSLComplete()) ||
        (cardStatus.value === "AutoSSL" && !isAutoSSLComplete())));

  const handleBack = () => {
    if (primary && step === 3) {
      navigate(`/account/${orgId}/${siteId}/domains-hosted`);
    } else if (step === 3) {
      navigate(
        `/account/${orgId}/${siteId}/domains-hosted?status=point-your-domain`,
      );
    } else if (step === 2) {
      navigate(`/account/${orgId}/${siteId}/domains-hosted`);
      flushState();
    } else if (step === 1) {
      navigate(`/account/${orgId}/${siteId}/domains-hosted`);
      flushStateVariables();
    }
  };

  const handleNext = () => {
    if (step === 1 && !domainError && !domainAPI) {
      handleDomainAPI();
    } else if (step === 2 && isEbsSite) {
      // a live domain that lost its validation record: Verify just confirms it is back
      // (AWS renews through it), then returns to the list
      if (ebsDomain?.status === "UPDATED") {
        verifyEbsDns((verified) => {
          if (verified) navigate(`/account/${orgId}/${siteId}/domains-hosted`);
        });
        return;
      }
      // the validation CNAME is checked now; once it resolves the domain goes live
      // (and becomes the primary one) in the background
      verifyEbsDns((verified) => {
        if (!verified) return;
        installInstanceDomain(undefined, (success) => {
          if (!success) setShowFailedPage(true);
        });
        setStep(4);
      });
    } else if (step === 2) {
      navigate(`/account/${orgId}/${siteId}/domains-hosted?status=add-ssl`);
      // } else if (step === 3 && isDedicated) {
      //   installInstanceDomain();
      //   setStep(4);
    } else if (step === 3 && !showPointYourDomain) {
      if (cardStatus.value === "UploadSSL" && isUploadSSLComplete()) {
        uploadClick();
      } else if (cardStatus.value === "AutoSSL" && isAutoSSLComplete()) {
        autoClick();
      }
    } else if (step === 3 && showPointYourDomain) {
      verifySsl();
    }
  };

  const rows = [
    {
      recordName: "A",
      record: "@",
      ip: isDedicated ? siteData?.instanceIp : siteData?.ipAddress,
    },
    // { recordName: "A", record: "www", ip: siteData?.ipAddress },
  ];

  // v2: the ACM validation CNAME (keep it, AWS renews through it) + CloudFront CNAMEs
  const ebsRows = [
    ...(ebsDomain?.validationName
      ? [
          {
            recordName: "CNAME",
            record: ebsDomain.validationName,
            ip: ebsDomain.validationValue,
          },
        ]
      : []),
    { recordName: "CNAME", record: ebsDomain?.domainName, ip: ebsDomain?.cnameTarget },
    // www. domain: the bare domain can point at our IP, where it is redirected to www
    ...(ebsDomain?.domainName?.startsWith("www.") && ebsDomain?.apexIp
      ? [
          {
            recordName: "A",
            record: ebsDomain.domainName.slice(4),
            ip: ebsDomain.apexIp,
          },
        ]
      : []),
    ...(ebsDomain?.domainName?.startsWith("www.")
      ? []
      : [
          {
            recordName: "CNAME",
            record: `www.${ebsDomain?.domainName}`,
            ip: ebsDomain?.cnameTarget,
          },
        ]),
  ];

  const rowsVerify = sslAuthChallenge?.keys?.map((key, index) => ({
    recordName: "TXT",
    record: `_acme-challenge.${data || domainName}`,
    ip: key?.value,
  }));

  return (
    <Grid2 className={styles.AddDomainContainer}>
      <Grid2>
        <Breadcrumbs
          aria-label="breadcrumb"
          separator={<div className={styles.separatorColor}>/</div>}
        >
          <Grid2 className={styles.options} onClick={handleBack}>
            <Grid2>Domain Hosting</Grid2>
          </Grid2>
          <Grid2 className={styles.activeOption}>Add domain</Grid2>
        </Breadcrumbs>
        <Grid2 className={styles.headerFlexbox}>
          <Grid2 className={styles.header}>Domain Details</Grid2>
          <Grid2 className={styles.subHeader}>
            Get started with your domain in just two simple steps.
          </Grid2>
        </Grid2>
      </Grid2>
      <DomainStepper currentStep={step} ebsSite={isEbsSite} />

      <Grid2 className={styles.domainbg}>
        <Grid2>
          {showFailedPage && <FailedPage message={failedMessage} />}
          {!showFailedPage && step === 1 && (
            <DomainDetails
              domainName={domainName}
              siteData={siteData}
              checkAndSetDomainValue={checkAndSetDomainValue}
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
              setDomainName={setDomainName}
            />
          )}
          {!showFailedPage && step === 2 && isEbsSite && !ebsDomain && (
            <Grid2 style={{ display: "flex", justifyContent: "center", padding: "48px 0" }}>
              <CircularProgress size={40} />
            </Grid2>
          )}
          {!showFailedPage && step === 2 && isEbsSite && ebsDomain && (
            <PointYourDomain
              header={
                ebsDomain?.status === "UPDATED"
                  ? "Check your DNS records"
                  : "Add these DNS records at your domain provider"
              }
              subHeader={
                ebsDomain?.status === "UPDATED"
                  ? "AWS renews this domain's SSL certificate through the first record, and it isn't resolving right now. Add it back at your domain provider exactly as shown, then click Verify."
                  : ebsDomain?.domainName?.startsWith("www.") && ebsDomain?.apexIp
                    ? "The first record proves you own the domain and lets AWS issue and renew the SSL certificate automatically — keep it permanently. The CNAME sends visitors to your site. The A record is optional: it sends visitors who type the bare domain on to www."
                    : "The first record proves you own the domain and lets AWS issue and renew the SSL certificate automatically — keep it permanently. The others send visitors to your site. If your provider doesn't allow a CNAME or ALIAS on the root domain, add www.<your domain> as the domain instead: you'll then get an A record for the root that sends visitors on to www."
              }
              tableHeader={["Type", "Name", "Value"]}
              rows={ebsRows}
              preVer={true}
              dnsVerified={dnsVerified}
              dnsChecking={dnsChecking}
            />
          )}
          {!showFailedPage && step === 2 && !isEbsSite && (
            <PointYourDomain
              header="Point Your Domain"
              subHeader="Copy the IP address above, log into your domain provider, and update your DNS settings to direct traffic to your site"
              tableHeader={["Record", "Record Type", "Destination / Target"]}
              rows={rows}
              preVer={true}
              dnsVerified={dnsVerified}
              dnsChecking={dnsChecking}
            />
          )}
          {!showFailedPage && step === 3 && !isEbsSite && (
            <>
              {!showPointYourDomain && (
                <AddSSL
                  domainName={domainName}
                  setSslData={setSslData}
                  ssldata={ssldata}
                  privateKeyError={privateKeyError}
                  certificateChainError={certificateChainError}
                  sslAutoData={sslAutoData}
                  sslAutoDataErr={sslAutoDataErr}
                  setSSLAutoData={setSSLAutoData}
                  tos={tos}
                  setTos={setTos}
                  cardStatus={cardStatus}
                  selectTab={selectTab}
                />
              )}
              {showPointYourDomain && (
                <PointYourDomain
                  header="Pre-verify domain"
                  subHeader="Pre-verify your domain if it receives significant traffic to prevent delays when updating your DNS"
                  tableHeader={[
                    "Record",
                    "Host / Label",
                    "Destination / Target",
                  ]}
                  rows={rowsVerify}
                  preVer={false}
                />
              )}
            </>
          )}
          {!showFailedPage && step === 4 && (
            <>
              {showLoading && <DoaminLoading />}
              {!showLoading && showReadyPage && (
                <ReadyPage />
              )}
            </>
          )}
        </Grid2>
        {!showFailedPage && step !== 4 && (
          <Grid2 className={styles.bottom}>
            <Grid2 className={styles.line} />
            <Grid2 className={styles.buttonFlex}>
              <Grid2 className={styles.Back} onClick={handleBack}>
                {step === 2 ? "I'll do this later" : "Back"}
              </Grid2>
              <CustomButton
                className={styles.Next}
                onClick={handleNext}
                disabled={isButtonDisabled || installing}
              >
                {loading ? (
                  <CircularProgress size={CP.SIZE} color={CP.COLOR} />
                ) : step === 2 ? (
                  isEbsSite && ebsDomain?.status === "UPDATED" ? "Verify" : "I've done this"
                ) : step === 3 && showPointYourDomain ? (
                  "Verify"
                ) : (
                  "Next"
                )}
              </CustomButton>
            </Grid2>
          </Grid2>
        )}
      </Grid2>
    </Grid2>
  );
}
